// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__9C9FJ","subTitle":"Settings_subTitle__hGoH9"};